import * as React from 'react';
import { IndexTile } from '../IndexTile';
import { Category } from '../../../../models';
import './style.css';

export interface CategoryTileProps {
  category: Category;
}

export interface CategoryTileState {
  /* empty*/
}

export class CategoryTile extends React.Component<
  CategoryTileProps,
  CategoryTileState
> {
  render() {
    const { category } = this.props;

    return (
      <IndexTile
        className="category-tile"
        image={category.image}
        url={category.route}
      >
        <div className="category-tile-text">{category.name}</div>
      </IndexTile>
    );
  }
}

export default CategoryTile;



// WEBPACK FOOTER //
// ./src/app/components/CategoryIndex/CategoryTiles/CategoryTile/index.tsx